import { useState } from 'react';
import './SpinningDice.css';

interface SpinningDiceProps {
  size?: number;
  freeze?: boolean;
}

const PIP_POSITIONS: Record<number, number[]> = {
  1: [5],
  2: [1, 9],
  3: [1, 5, 9],
  4: [1, 3, 7, 9],
  5: [1, 3, 5, 7, 9],
  6: [1, 3, 4, 6, 7, 9],
};

const Face: React.FC<{ value: number; transform: string }> = ({ value, transform }) => (
  <div className="diceFace" style={{ transform }}>
    {PIP_POSITIONS[value].map(p => <span key={p} className={`dicePip p${p}`} />)}
  </div>
);

const SpinningDice: React.FC<SpinningDiceProps> = ({ size = 110, freeze }) => {
  const [freezeFace] = useState(() => Math.floor(Math.random() * 6) + 1);
  const half = size / 2;
  const faceTransforms: [number, string][] = [
    [1, `translateZ(${half}px)`],
    [6, `rotateY(180deg) translateZ(${half}px)`],
    [3, `rotateY(90deg) translateZ(${half}px)`],
    [4, `rotateY(-90deg) translateZ(${half}px)`],
    [5, `rotateX(90deg) translateZ(${half}px)`],
    [2, `rotateX(-90deg) translateZ(${half}px)`],
  ];
  return (
    <div className="spinningDiceScene" style={{ width: size * 1.6, height: size * 1.6 }} aria-hidden="true">
      <div className={`spinningDice${freeze ? ` spinningDiceFreeze f${freezeFace}` : ''}`} style={{ width: size, height: size }}>
        {faceTransforms.map(([v, t]) => <Face key={v} value={v} transform={t} />)}
      </div>
    </div>
  );
};

export default SpinningDice;
